import { $$ } from '../../../shared/js/utils/dom';
import Cookiebanner from '../../../shared/js/modules/cookiebanner/cookiebanner';
import ToggleCookieOverlay from '../../atoms/cookie-overlay/cookie-overlay';

const siteId = 20;

new Cookiebanner({
  cookieName: 'Meta-IFiF-Cookie',
  cookieDuration: 36500,
  cookieTypes: [
    {
      name: {
        de: 'Notwendige Cookies',
      },
      text: {
        de: '<p>Diese Cookies sind für den Betrieb unserer Websites technisch notwendig und immer aktiviert. Hierzu zählen z.B. sogenannte Session-Cookies, die nach Ende Ihres Besuchs automatisch gelöscht werden.</p>',
      },
      type: 'required',
    },
    {
      name: {
        de: 'Matomo',
      },
      text: {
        de: `Auf dieser Website werden mit Matomo, einem Open-Source Web-Analyse-Tool (<a class="styled-link styled-link--external" href="https://matomo.org" target="_blank" rel="noopener noreferrer"><span class="sr-only">Externer Link:</span>https://matomo.org<span class="styled-link__icon icon icon--arrow-external"><svg class="icon__svg" focusable="false" role="img" aria-hidden="true"><use href="#icon-arrow-external"></use></svg></span></a>), Daten zu Marketing- und Optimierungszwecken gesammelt und gespeichert. Das Tool verwendet Cookies. Aus diesen Daten können unter einem Pseudonym Nutzungsprofile erstellt werden. Dafür wird Ihre IP-Adresse anonymisiert; der Websitebetreiber hat keine technische Möglichkeit, Sie damit als angemeldeten Nutzer zu identifizieren.</p><p><strong>Sie können Ihre Cookie-Einstellungen jederzeit ändern und die Änderung durch erneutes Laden der Internetseite aktivieren.</strong></p>`,
      },
      type: 'script',
      subType: 'matomo',
      isChecked: 'checked',
      trackingScripts: [
        {
          insertSelector: 'body',
          script: `
            var _paq = window._paq = window._paq || [];
            /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
            _paq.push(["setDocumentTitle", document.domain + "/" + document.title]);
            _paq.push(["setDomains", ["*.meta-ifif.de","*.innovative-frauen-im-fokus.de"]]);
            _paq.push(["setDoNotTrack", true]);
            _paq.push(["disableCookies"]);
            _paq.push(['trackPageView']);
            _paq.push(['enableLinkTracking']);
            (function() {
                var u="https://webstats.kompetenzz.net/webstats/";
                _paq.push(['setTrackerUrl', u+'matomo.php']);
                _paq.push(['setSiteId', '${siteId}']);
                var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
            })();`,
        },
      ],
    },
    {
      name: {
        de: 'Filme',
      },
      text: {
        de: `<p>Wir binden auf unseren Websites Videos von YouTube ein, einem Plattform-Dienst der Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.</p><h2>YouTube</h2><p>Damit Sie sich in Filmen über unsere Angebote, Einrichtungen und Mitarbeitenden informieren können, binden wir auf unseren Websites Videos von unseren eigenen YouTube-Kanälen im erweiterten Datenschutzmodus ein.</p><h2>Live-Streaming von Events</h2>
            <p>Damit Sie live über das Internet an Veranstaltungen teilnehmen können, übertragen wir ausgewählte Events als eingebetteten Live-Stream auf unseren Websites. Dazu nutzen wir Vimeo, einen Service der Vimeo, Inc. 555 West 18th Street, New York, New York 10011, USA.</p><p><strong>Sie können Ihre Cookie-Einstellungen jederzeit ändern und die Änderung durch erneutes Laden der Internetseite aktivieren.</strong></p>`,
      },
      type: 'videojs',
      subType: 'videojs',
    },
    // {
    //   name: {
    //     de: 'Karten',
    //   },
    //   text: {
    //     de: `<p>Wir binden auf unseren Websites Standortkarten unter Verwendung von Google Maps ein, einem Kartendienst der Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.</p><h3>Google Maps</h3><p>Um geographische Informationen zu den Standorten unserer Einrichtungen darzustellen und die Möglichkeit einer Routenplanung zu geben, verwenden wir die Google Maps Programmierschnittstelle.</p><p><strong>Sie können Ihre Cookie-Einstellungen jederzeit ändern und die Änderung durch erneutes Laden der Internetseite aktivieren.</strong></p>`,
    //   },
    //   type: 'embed',
    //   subType: 'map',
    // },
    {
      name: {
        de: 'Eingebettete Inhalte',
      },
      text: {
        de: `<p>Gelegentlich werden ausgewählte Inhalte von Fremdbetreibern oder Dienstleistern eingebettet, um erweiterte Funktionen und Services auf dieser Website anbieten zu können.</p>
            <h2>Live-Streaming von Events</h2>
            <p>Ausgewählte Events übertragen wir als eingebetteten Live-Stream auf unserer Website. Dazu nutzen wir YouTube, einen Plattform-Dienst der Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.</p>
            <h2>Karten</h2>
            <p>Auf dieser Webseite werden gelegentlich interaktive Karten via Google Maps eingebunden, einem Kartendienst der Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA. Sinn und Zweck der geographischen Informationen ist es, Standorte darzustellen und die Möglichkeit einer Routenplanung zu geben. Google erhebt dazu eigene Daten. Um die Karten zu sehen, muss diese Option aktiviert werden.</p>
            `,
      },
      type: 'embed',
      subType: 'embed',
    },
  ],
  onThirdPartyInit: subType => {
    const overlayWrappers = $$(`.cookie-overlay[data-type="${subType}"]`);
    overlayWrappers.length &&
      overlayWrappers.forEach(overlayWrapper => {
        new ToggleCookieOverlay({
          container: overlayWrapper,
          subType,
        }).init();
      });
  },
}).init();
